import { Box, Image, Tooltip } from "@chakra-ui/react";
import React from "react";
import CustomLabelToolTip from "./customLabelToolTip";
import { customToolTipVariant } from "./ToolTipStyles";

const CustomToolTip = ({ data, icon, variant }) => {
  let iconVariant =
    variant === "TaskCard" || "Login"
      ? customToolTipVariant?.TaskCardIcon
      : variant === "UpdatesMobile"
      ? customToolTipVariant?.updatesMobileIcon
      : variant === "UpdatesDesktop"
      ? customToolTipVariant?.updatesDesktopIcon
      : "";
  let subtopicText =
    variant === "TaskCard" ||
    variant === "UpdatesMobile" ||
    variant === "UpdatesDesktop"
      ? "Subtopics included -"
      : variant === "Login"
      ? ""
      : "";
  let toolTipStyle =
    variant === "Login"
      ? customToolTipVariant?.loginTipBox
      : customToolTipVariant?.toolTipBox;
  let placementStyle = variant === "Login" ? "top" : "auto";
  return (
    <Tooltip
      label={
        <CustomLabelToolTip
          subtopicText={subtopicText}
          subtopicNames={data}
          variant={variant}
        />
      }
      placement={placementStyle}
      sx={toolTipStyle}
    >
      <Box>
        <Image src={icon} sx={iconVariant} />
      </Box>
    </Tooltip>
  );
};

export default CustomToolTip;
